<div *ngIf="translateService.currentLang==='en'">
  <div id="main-content" class="highlighted-container container">
    <div class="row">
      <div class="highlighted">
        <div class="region region-highlighted">
          <div data-drupal-messages-fallback="" class="hidden"></div>
          <h1 class="page-header">
            <span>Making Our Clients a Priority</span>
          </h1>
        </div>
      </div>
    </div>
  </div>

  <div role="main" class="main-container container js-quickedit-main-content">
    <div class="row">
      <section class="col-sm-9">
        <div class="region region-content">
          <section id="block-cdlsifaqheader" class="block clearfix">
            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item"><p class="big green"><a name="top"></a><strong>We are here to offer assistance and answer any questions you might have pertaining to your lease.</strong></p>
              <p><strong>CDLSI will help you and provide support</strong> throughout the lease lifecycle: from the time the vehicle is driven off the dealership’s lot to lease end.<br>&nbsp;</p>
              <h2 class="red">Frequently Asked Questions</h2>
              <p><strong>Learn about your account with CDLSI.</strong> If you do not find what you are looking for below, please contact our client relations team by email at <a href="mailto:clientrelations@cdlsi.com">clientrelations&#64;cdlsi.com</a> or call 1.888.703.5765 and they will be happy to help.</p>
            </div>
          </section>
          <div class="faq-content">
            <div class="faq">
              <div class="faq-category-group">
                <div class="faq-qa-header">
                  <h3 class="faq-header">Insurance</h3>
                </div>
                <div class="faq-qa">
                  <div class="faq-question-answer">
                    <div class="faq-question" role="button" aria-expanded="false" aria-controls="t1n10" (click)="t1n10Visible=!t1n10Visible">
                      <a href="javascript:" id="t1n10key">What are the insurance coverage requirements?</a>
                    </div>
                    <div class="faq-answer" id="t1n10" *ngIf="t1n10Visible">
                      <article class="faq full clearfix" aria-expanded="false">
                        <div class="content">
                          <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                            <p>All leased vehicles must have the following insurance coverage: 1) The lessee and/or co-lessee must be listed as named insured 2) Third party liability of a not less than $1,000,000 3) Both Collision and comprehensive coverage or all perils coverage with a maximum deductible as listed in your Retail Lease Agreement 4) &nbsp;Canadian Dealer Lease Services Inc, (PO Box 8138, Station “T”, Ottawa, ON, K1G 4K4) must be designated as the Lessor or additional Insured on the policy. 5) Permission to rent or lease endorsement (5a) or equivalent (where applicable).</p>
                          </div>
                        </div>
                      </article>
                      <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()" (click)="backToTop()">Back to Top</a>
                    </div>
                  </div>

                  <div class="faq-question-answer">
                    <div class="faq-question" role="button" aria-expanded="false" aria-controls="t1n11" (click)="t1n11Visible=!t1n11Visible">
                      <a href="javascript:" id="t1n11key">How can I provide a copy of my insurance?</a>
                    </div>
                    <div class="faq-answer" id="t1n11" *ngIf="t1n11Visible">
                      <article class="faq full clearfix" aria-expanded="false">
                        <div class="content">
                          <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                            <p>You may provide a copy of your current insurance policy to us either via email at <a href="mailto:insurance@cdlsi.com" (click)="onInsuranceEmailClick()">insurance&#64;cdlsi.com</a> via fax at 1 (888) 517-3622, or, by mailing it to PO Box 8138 Station T, Ottawa, ON K1G 4K4. Please be advised that insurance liability cards (“pink slips”) are not acceptable as this document does not contain all the required information listed per the insurance requirements above.</p>
                          </div>
                        </div>
                      </article>
                      <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                    </div>
                  </div>

                  <div class="faq-question-answer">
                    <div class="faq-question" role="button" aria-expanded="false" aria-controls="t1n18" (click)="t1n18Visible=!t1n18Visible">
                      <a href="javascript:" id="t1n18key">Why must CDLSI be listed as Lessor on the insurance policy?</a>
                    </div>
                    <div class="faq-answer" id="t1n18" *ngIf="t1n18Visible">
                      <article class="faq full clearfix" aria-expanded="false">
                        <div class="content">
                          <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                            <p>CDLSI, as owner of the leased vehicle, must be listed as lessor so we are notified by the insurance company in the case of a total loss of the leased vehicle.  We are also notified by the insurance company of any changes to the insurance coverage on the leased vehicle.  Most insurance companies will also mail a copy of your insurance policy upon renewal to us.</p>
                          </div>
                        </div>
                      </article>
                      <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                    </div>
                  </div>

                  <div class="faq-question-answer">
                    <div class="faq-question" role="button" aria-expanded="false" aria-controls="t1n19" (click)="t1n19Visible=!t1n19Visible">
                      <a href="javascript:" id="t1n19key">What steps do I take if my vehicle has been stolen or deemed a total loss?</a>
                    </div>
                    <div class="faq-answer" id="t1n19" *ngIf="t1n19Visible">
                      <article class="faq full clearfix" aria-expanded="false">
                        <div class="content">
                          <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                            <p>You may contact our office to advise us if your leased vehicle has been stolen or deemed a total loss however, it is also important that the insurance company contact our office to initiate the total loss claim with us. Once the claim is initiated with our office, we will work directly with the insurance company to settle the total loss claim. We ask that you or your insurance provider inform us as soon as possible. We will work diligently with your insurance provider to resolve the matter. Please note that the pre-authorized payments will continue to be withdrawn until a settlement has been received.</p>
                          </div>
                        </div>
                      </article>
                      <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                    </div>
                  </div>

                  <div class="faq-question-answer">
                    <div class="faq-question" role="button" aria-expanded="false" aria-controls="t1n20" (click)="t1n20Visible=!t1n20Visible">
                      <a href="javascript:" id="t1n20key">Is storage insurance acceptable?</a>
                    </div>
                    <div class="faq-answer" id="t1n20" *ngIf="t1n20Visible">
                      <article class="faq full clearfix" aria-expanded="false">
                        <div class="content">
                          <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                            <p>Storage insurance is not permitted at any time on the leased vehicle. The vehicle must remain fully insured at all times in accordance with the insurance requirements outlined in your Retail Lease Agreement.  No exceptions will be granted.</p>
                          </div>
                        </div>
                      </article>
                      <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                    </div>
                  </div>
                  <div class="faq-question-answer">
                    <div class="faq-question" role="button" aria-expanded="false" aria-controls="t1n21" (click)="t1n21Visible=!t1n21Visible">
                      <a href="javascript:" id="t1n21key">Why am I being contacted for insurance documents and why doesn’t CDLSI have a copy of my policy?</a>
                    </div>
                    <div class="faq-answer" id="t1n21" *ngIf="t1n21Visible">
                      <article class="faq full clearfix" aria-expanded="false">
                        <div class="content">
                          <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                            <p>When a vehicle is leased, as per the Retail Lease Agreement, proof of valid insurance is needed throughout the lease term. Not all insurance companies or brokers provide us with proof of renewal or when there is a change with the insurance carrier. Unfortunately, in those cases, we must reach out to our leased customer directly to get proof of insurance or renewal. As the Lessor, we may contact you either by phone, email or mail to collect proof of insurance so we can update your account with the most updated insurance coverage information.</p>
                          </div>
                        </div>
                      </article>
                      <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="faq-category-group">
                <div class="faq-qa-header">
                  <h3 class="faq-header">Your Account Queries</h3>
                </div>

                <div class="faq-qa">
                  <div class="faq-dl-hide-answer">
                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n13" (click)="t2n13Visible=!t2n13Visible">
                        <a href="javascript:" id="t2n13key">How do I change my banking information?</a>
                      </div>
                      <div class="faq-answer" id="t2n13" *ngIf="t2n13Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>
                                <a routerLink="/request-list">Here is a link to our Self-Serve so you can update your banking information now</a>
                                . We will require your new account number, branch and transit numbers. Some exceptions apply. If your banking information is for a business you own for example, we will require articles of incorporation along with a copy of the void cheque.
                              </p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n14" (click)="t2n14Visible=!t2n14Visible">
                        <a href="javascript:" id="t2n14key">I am moving, do I inform you?</a>
                      </div>
                      <div class="faq-answer" id="t2n14" *ngIf="t2n14Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>
                                Yes, it is important to inform us.
                                <a routerLink="/request-list">Here is a link to our Self-Serve so you can update your home address now</a>.
                                We will require relevant documents showing your new address. The list of required documents is outlined in the Self-Serve section. Depending on the province in which you are relocating to, the taxes on your monthly or bi-weekly payment may also need to be adjusted.
                              </p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n15" (click)="t2n15Visible=!t2n15Visible">
                        <a href="javascript:" id="t2n15key">Can I travel outside of my territory?</a>
                      </div>

                      <div class="faq-answer" id="t2n15" *ngIf="t2n15Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Please contact our Client Relations department (1.888.703.5765) to discuss further. Prior approval is required, and some exceptions may be granted.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n21" (click)="t2n21Visible=!t2n21Visible">
                        <a href="javascript:" id="t2n21key">I missed a payment; how do I bring my account up to date?</a>
                      </div>
                      <div class="faq-answer" id="t2n21" *ngIf="t2n21Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Please call 1.800.909.9127 immediately to discuss your account with our Payment Arrangement department.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n22" (click)="t2n22Visible=!t2n22Visible">
                        <a href="javascript:" id="t2n22key">What if I exceed my kilometre allowance?</a>
                      </div>
                      <div class="faq-answer" id="t2n22" *ngIf="t2n22Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Any excess kilometres are your responsibility as stated in the Retail Lease Agreement. The lease agreement also states the charge per excess kilometre which will be reflected on your end of term invoice.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n23" (click)="t2n23Visible=!t2n23Visible">
                        <a href="javascript:" id="t2n23key">Can I change my payment due date?</a>
                      </div>
                      <div class="faq-answer" id="t2n23" *ngIf="t2n23Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>
                                Yes, although there are some limitations.
                                <a routerLink="/request-list">Here is a link to our Self-Serve to determine eligibility and options</a>.
                              </p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n24" (click)="t2n24Visible=!t2n24Visible">
                        <a href="javascript:" id="t2n24key">Can I transfer my lease?</a>
                      </div>
                      <div class="faq-answer" id="t2n24" *ngIf="t2n24Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>It is possible to transfer your lease, however, it is best to contact your dealership to discuss options.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n25" (click)="t2n25Visible=!t2n25Visible">
                        <a href="javascript:" id="t2n25key">Are there any fees to transfer my lease?</a>
                      </div>
                      <div class="faq-answer" id="t2n25" *ngIf="t2n25Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Yes, there is a fee. Please refer to your Retail Lease Agreement under the “Other Terms” clause.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n26" (click)="t2n26Visible=!t2n26Visible">
                        <a href="javascript:" id="t2n26key">How do I initiate a lease transfer?</a>
                      </div>
                      <div class="faq-answer" id="t2n26" *ngIf="t2n26Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Please contact your dealership to initiate the lease assignment process which will involve the completion and approval of a credit application by the transferee(s). &nbsp;Once a credit approval is provided to the dealership, Canadian Dealer Lease Services will work directly with your dealership to ensure all required documentation is completed and signed. &nbsp;The lease assignment fee will also be collected by your dealership at the time of the lease transfer.</p>

                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div class="faq-category-group">
                <div class="faq-qa-header">
                  <h3 class="faq-header">End of Lease</h3>
                </div>
                <div class="faq-qa">

                  <div class="faq-dl-hide-answer">
                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t3n16" (click)="t3n16Visible=!t3n16Visible">
                        <a href="javascript:" id="t3n16key">What end of lease options do I have?</a>
                      </div>
                      <div class="faq-answer" id="t3n16" *ngIf="t3n16Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Your options are as follows:&nbsp;</p>
                              <ul><li>Return the vehicle to the dealership, or</li><li>Purchase the vehicle, or</li><li><a routerLink="/customer-intent">Submit end of lease intent.</a></li></ul>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t3n17" (click)="t3n17Visible=!t3n17Visible">
                        <a href="javascript:" id="t3n17key">Am I responsible for repairs?</a>
                      </div>
                      <div class="faq-answer" id="t3n17"  *ngIf="t3n17Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p><strong>Option 1: </strong>You may repair your vehicle at your dealership or at a garage authorized by your dealer. If you purchased any excess wear and tear product, please contact your dealer to assist you.</p><p><strong>Option 2:</strong> You can choose to do repairs at a garage of your choice. Once repairs are completed, a 2nd inspection will be necessary at an additional cost. To find out more about the cost, please call us.</p><p><strong>Option 3:</strong> You may return your vehicle without making any repairs. In that case, we will send you an invoice for the excess wear and tear items plus any outstanding amounts. Please note, in most cases vehicles are sold in the state they were returned with full disclosures.</p><p>&nbsp;</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t3n27" (click)="t3n27Visible=!t3n27Visible">
                        <a href="javascript:" id="t3n27key">Can I return my lease early?</a>
                      </div>
                      <div class="faq-answer" id="t3n27" *ngIf="t3n27Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Please contact our Client Relations department (1.888.703.5765) to discuss available options.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t3n28" (click)="t3n28Visible=!t3n28Visible">
                        <a href="javascript:" id="t3n28key">I purchased a Lease End product; how do I proceed?</a>
                      </div>
                      <div class="faq-answer" id="t3n28" *ngIf="t3n28Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>With so many products available, we recommend discussing your specific protection coverage with your dealer.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="faq-category-group">
                <div class="faq-qa-header">
                  <h3 class="faq-header">Inspection</h3>
                </div>

                <div class="faq-qa">
                  <div class="faq-dl-hide-answer">

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t4n29" (click)="t4n29Visible=!t4n29Visible">
                        <a href="javascript:" id="t4n29key">Who is OPENLANE Inspections?</a>
                      </div>
                      <div class="faq-answer" id="t4n29" *ngIf="t4n29Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>OPENLANE Inspections (formerly AutoVIN) is a 3<sup>rd</sup> party company hired by us to complete the vehicle inspection process.&nbsp;</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t4n30" (click)="t4n30Visible=!t4n30Visible">
                        <a href="javascript:" id="t4n30key">Why is an inspection required?</a>
                      </div>
                      <div class="faq-answer" id="t4n30" *ngIf="t4n30Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Unless you are purchasing the vehicle, an inspection is required to assess any excess wear and tear on the vehicle prior to its return.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t4n31" (click)="t4n31Visible=!t4n31Visible">
                        <a href="javascript:" id="t4n31key">Do I have to be present during the inspection?</a>
                      </div>
                      <div class="faq-answer" id="t4n31" *ngIf="t4n31Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>No, it is not necessary. The inspector will conduct the inspection at a location of your choosing. Typically, results are available online within 24-48 hours. If you are unsure where or how to view your results, contact your dealer or our Client Relations department (1.888.703.5765).</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t4n32" (click)="t4n32Visible=!t4n32Visible">
                        <a href="javascript:" id="t4n32key">What number should I call to schedule my inspection?</a>
                      </div>
                      <div class="faq-answer" id="t4n32" *ngIf="t4n32Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>To schedule an inspection please call our Client Relations department (1.888.703.5765).</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t4n33" (click)="t4n33Visible=!t4n33Visible">
                        <a href="javascript:" id="t4n33key">How long is the inspection valid for?</a>
                      </div>
                      <div class="faq-answer " id="t4n33" *ngIf="t4n33Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>The inspection is valid for 60 days. If the vehicle is not returned within 60 days after the inspection, a second inspection is required and will be charged to the lessee. &nbsp;However, the first inspection is complimentary.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t4n34" (click)="t4n34Visible=!t4n34Visible">
                        <a href="javascript:" id="t4n34key">How do I confirm that CDLSI received confirmation of repairs?</a>
                      </div>
                      <div class="faq-answer" id="t4n34" *ngIf="t4n34Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>It is important for us to receive a copy of the repair receipts to waive damages that were repaired. To confirm receipt, please contact our Client Relations department (1.888.703.5765).</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
      <aside class="col-sm-3">
        <div class="region region-sidebar-second">
          <section id="block-forlesseessidebar" class="block block-block-content clearfix">
            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
              <p class="btn btn-secondary">
                <button type="button" class="btn btn-secondary" (click)="submitInsuranceInfo()">Submit Insurance <br> Policy Documents</button>
              </p>
            </div>
          </section>
        </div>
      </aside>
    </div>
  </div>
</div>

<div *ngIf="translateService.currentLang==='fr'">
  <div id="main-content" class="highlighted-container container">
    <div class="row">
      <div class="highlighted">
        <div class="region region-highlighted">
          <div data-drupal-messages-fallback="" class="hidden"></div>
          <h1 class="page-header">
            <span>Nos clients sont notre priorité</span>
          </h1>
        </div>
      </div>
    </div>
  </div>

  <div role="main" class="main-container container js-quickedit-main-content">
    <div class="row">
      <section class="col-sm-9">
        <div class="region region-content">
          <section id="block-cdlsifaqheader" class="block block-block-content clearfix">
            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item"><p class="big green"><a name="top"></a><strong>Nous sommes là pour vous aider et répondre à toutes vos questions concernant votre location.</strong></p>
              <p><strong>CDLSI vous aidera et vous fournira un soutien</strong> tout au long de la période de la location: à partir du moment où le véhicule est en votre possession jusqu’à la fin de la location.<br>&nbsp;</p>
              <h2 class="red">Foire Aux Questions</h2>
              <p><strong>En savoir plus sur votre compte chez CDLSI.</strong> Si vous ne trouvez pas ce que vous cherchez ci­-dessous, veuillez contacter notre équipe de la relation client par courriel à <a href="mailto:relationclientele@cdlsi.com">relationclientele&#64;cdlsi.com</a> ou appelez le 1.888.703.5765 et ils se feront un plaisir de vous aider</p>
            </div>
          </section>
          <div class="faq-content">
            <div class="faq">

              <div class="faq-category-group">
                <div class="faq-qa-header">
                  <h3 class="faq-header">Insurance</h3>
                </div>
                <div class="faq-qa">
                  <div class="faq-question-answer">
                    <div class="faq-question" role="button" aria-expanded="false" aria-controls="t1n10" (click)="t1n10Visible=!t1n10Visible">
                      <a href="javascript:" id="t1n10key">Quelles sont les exigences en matière de couverture d’assurance?</a>
                    </div>
                    <div class="faq-answer" id="t1n10" *ngIf="t1n10Visible">
                      <article class="faq full clearfix" aria-expanded="false">
                        <div class="content">
                          <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                            <p>Tous les véhicules loués doivent avoir la couverture d’assurance suivante : 1) Le locataire et/ou le colocataire doit-être inscrit comme assuré désigné 2) Responsabilité civile d’au moins 1 000 000 $ 3) Couverture dommages accident par collision et garantie accidents sans collision ni versement ou toute couverture des risques avec une franchise maximale, telle qu’elle est indiquée dans votre contrat de location au détail 4) Services de location des concessionnaires automobiles canadiens, (boîte postale 8138, Station “T”, Ottawa, ON, K1G 4K4) doit être désigné comme locateur ou assuré additionnel sur la police. 5) Permission de louer ou avenant de location (5a) ou l’équivalent (le cas échéant).</p>
                          </div>
                        </div>
                      </article>
                      <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                    </div>
                  </div>

                  <div class="faq-question-answer">
                    <div class="faq-question" role="button" aria-expanded="false" aria-controls="t1n11" (click)="t1n11Visible=!t1n11Visible">
                      <a href="javascript:" id="t1n11key">Comment puis-je fournir une copie de mon assurance?</a>
                    </div>
                    <div class="faq-answer" id="t1n11" *ngIf="t1n11Visible">
                      <article class="faq full clearfix" aria-expanded="false">
                        <div class="content">
                          <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                            <p>Vous pouvez nous fournir une copie de votre police d’assurance actuelle par courriel à <a href="mailto:assurance@cdlsi.com" (click)="onAssuranceEmailClick()">assurance&#64;cdlsi.com</a> par télécopieur au 1 (888) 517-3622, ou, par la poste à boîte postale 8138 Station T, Ottawa, ON K1G 4K4. Veuillez noter que les cartes d’assurance responsabilité (« feuillets roses ») ne sont pas acceptables, car ce document ne contient pas tous les renseignements requis énumérés selon les exigences d’assurance ci-dessus.</p>
                          </div>
                        </div>
                      </article>
                      <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                    </div>
                  </div>

                  <div class="faq-question-answer">
                    <div class="faq-question" role="button" aria-expanded="false" aria-controls="t1n18" (click)="t1n18Visible=!t1n18Visible">
                      <a href="javascript:" id="t1n18key">Pourquoi CDLSI doit-elle être inscrit à titre de locateur sur la police d’assurance?</a>
                    </div>
                    <div class="faq-answer" id="t1n18" *ngIf="t1n18Visible">
                      <article class="faq full clearfix" aria-expanded="false">
                        <div class="content">
                          <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                            <p>CDLSI, en tant que propriétaire du véhicule loué, doit être inscrit comme locateur afin que nous puissions être avisés par la compagnie d’assurance en cas de perte totale du véhicule loué. Nous sommes également avisés par la compagnie d’assurance de tout changement à la couverture d’assurance sur le véhicule loué. La plupart des compagnies d’assurance nous envoient également une copie de votre police d’assurance au moment du renouvellement.</p>
                          </div>
                        </div>
                      </article>
                      <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                    </div>
                  </div>

                  <div class="faq-question-answer">
                    <div class="faq-question" role="button" aria-expanded="false" aria-controls="t1n19" (click)="t1n19Visible=!t1n19Visible">
                      <a href="javascript:" id="t1n19key">Quelles mesures dois-je prendre si mon véhicule a été volé ou considéré comme une perte totale?</a>
                    </div>
                    <div class="faq-answer" id="t1n19" *ngIf="t1n19Visible">
                      <article class="faq full clearfix" aria-expanded="false">
                        <div class="content">
                          <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                            <p>Vous pouvez contacter notre bureau pour nous aviser si votre véhicule loué a été volé ou considéré comme une perte totale, mais il est également important que la compagnie d’assurance communique avec notre bureau pour amorcer une réclamation pour perte totale auprès de nous. Une fois la réclamation amorcée auprès de notre bureau, nous travaillerons directement avec la compagnie d’assurance pour régler la réclamation pour perte totale. Nous vous demandons, à vous ou à votre fournisseur d’assurance, de nous en informer le plus tôt possible. Nous travaillerons avec diligence avec votre fournisseur d’assurance pour résoudre le problème. Veuillez noter que les paiements préautorisés continueront d’être retirés jusqu’à ce qu’un règlement ait été reçu.</p>
                          </div>
                        </div>
                      </article>
                      <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                    </div>
                  </div>

                  <div class="faq-question-answer">
                    <div class="faq-question" role="button" aria-expanded="false" aria-controls="t1n20" (click)="t1n20Visible=!t1n20Visible">
                      <a href="javascript:" id="t1n20key">L’assurance entreposage est-elle acceptable?</a>
                    </div>
                    <div class="faq-answer" id="t1n20" *ngIf="t1n20Visible">
                      <article class="faq full clearfix" aria-expanded="false">
                        <div class="content">
                          <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                            <p>L’assurance entreposage sur le véhicule loué n’est permise à aucun moment. Le véhicule doit demeurer entièrement assuré en tout temps, conformément aux exigences d’assurance énoncées dans votre contrat de location au détail. Aucune exception ne sera accordée.</p>
                          </div>
                        </div>
                      </article>
                      <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                    </div>
                  </div>

                  <div class="faq-question-answer">
                    <div class="faq-question" role="button" aria-expanded="false" aria-controls="t1n21" (click)="t1n21Visible=!t1n21Visible">
                      <a href="javascript:" id="t1n21key">Pourquoi me demande-t-on des documents d'assurance et pourquoi CDLSI n'ont-ils pas une copie de ma police?</a>
                    </div>
                    <div class="faq-answer" id="t1n21" *ngIf="t1n21Visible">
                      <article class="faq full clearfix" aria-expanded="false">
                        <div class="content">
                          <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                            <p>Lorsqu'un véhicule est loué, conformément au contrat de location, une preuve d'assurance valide est requise pendant toute la durée du contrat. Toutes les compagnies d'assurance ou tous les courtiers ne nous fournissent pas systématiquement une preuve de renouvellement ou de changement d'assureur. Malheureusement, dans ces cas-là, nous devons contacter directement notre client locataire pour obtenir une preuve d'assurance ou de renouvellement. En tant que locateur, nous pouvons vous contacter par téléphone, par courriel ou par courrier afin de recueillir une preuve d'assurance et mettre à jour votre compte avec les informations les plus récentes concernant votre couverture d'assurance.</p>
                          </div>
                        </div>
                      </article>
                      <a href="javascript:" title="Go back to the top of the page." (click)="backToTop()">Back to Top</a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="faq-category-group">
                <div class="faq-qa-header">
                  <h3 class="faq-header">Questions sur votre compte</h3>
                </div>

                <div class="faq-qa">
                  <div class="faq-dl-hide-answer">
                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n13" (click)="t2n13Visible=!t2n13Visible">
                        <a href="javascript:" id="t2n13key">Comment puis-je modifier mes informations bancaires?</a>
                      </div>
                      <div class="faq-answer" id="t2n13" *ngIf="t2n13Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>
                                <a routerLink="/request-list">Voici un lien pour notre portail libre-service afin the modifier vos informations bancaires dès maintenant</a>.
                                Nous aurons besoin de votre nouveau numéro de compte, de votre succursale et de votre nouveau numéro de transit bancaire. Certaines exceptions s’appliquent. Si vos informations bancaires sont pour une entreprise que vous possédez, par exemple, nous exigerons les statuts constitutifs ainsi qu’une copie d’un spécimen chèque.
                              </p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n14" (click)="t2n14Visible=!t2n14Visible">
                        <a href="javascript:" id="t2n14key">Je déménage, est-ce que je vous en informe?</a>
                      </div>
                      <div class="faq-answer" id="t2n14" *ngIf="t2n14Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>
                                Oui, il est important de nous en informer.
                                <a routerLink="/request-list">Voici un lien pour notre libre-service afin de modifier votre adresse domicile</a>.
                                Nous exigerons une liste de documents pertinents indiquant votre nouvelle adresse. La liste des documents requis est indiquée dans la section libre-service. Selon la province où vous déménagez, les taxes sur votre paiement mensuel ou aux deux semaines peuvent également devoir être ajustées.
                              </p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n15" (click)="t2n15Visible=!t2n15Visible">
                        <a href="javascript:" id="t2n15key">Puis-je voyager à l’extérieur de mon territoire?</a>
                      </div>

                      <div class="faq-answer" id="t2n15" *ngIf="t2n15Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Veuillez contacter notre département de relation clients (1.888.703.5765) pour en discuter davantage. Une approbation préalable est requise et certaines exceptions peuvent être accordées.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n21" (click)="t2n21Visible=!t2n21Visible">
                        <a href="javascript:" id="t2n21key">J’ai raté un paiement; comment puis-je mettre mon compte à jour?</a>
                      </div>
                      <div class="faq-answer" id="t2n21" *ngIf="t2n21Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Veuillez appeler immédiatement au 1.800.909.9127 pour discuter de votre compte avec notre département d’arrangement de paiement.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n22" (click)="t2n22Visible=!t2n22Visible">
                        <a href="javascript:" id="t2n22key">Que se passe-t-il si je dépasse mon allocation de kilométrage?</a>
                      </div>
                      <div class="faq-answer" id="t2n22" *ngIf="t2n22Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Tout kilomètrage excédentaire est à votre charge, comme indiqué dans le contrat de location au détail. Le contrat de location indique également les frais par kilomètre excédentaire qui seront reflétés sur votre facture finale.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n23" (click)="t2n23Visible=!t2n23Visible">
                        <a href="javascript:" id="t2n23key">Puis-je modifier la date d’échéance de mon paiement?</a>
                      </div>
                      <div class="faq-answer" id="t2n23" *ngIf="t2n23Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>
                                Oui, mais il existe certaines restrictions.
                                <a routerLink="/request-list">Voici un lien pour notre libre-service qui vous permettra de déterminer votre admissibilité et les options qui s'offrent à vous</a>.
                              </p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n24" (click)="t2n24Visible=!t2n24Visible">
                        <a href="javascript:" id="t2n24key">Puis-je transférer mon bail?</a>
                      </div>
                      <div class="faq-answer" id="t2n24" *ngIf="t2n24Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Il est possible de transférer votre bail, cependant, il est préférable de contacter votre concessionnaire pour discuter des options.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n25" (click)="t2n25Visible=!t2n25Visible">
                        <a href="javascript:" id="t2n25key">Y a-t-il des frais si je transfère mon bail?</a>
                      </div>
                      <div class="faq-answer" id="t2n25" *ngIf="t2n25Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Oui, il y a des frais. Veuillez consulter votre contrat de location au détail, sous la clause « Autres conditions ».</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t2n26" (click)="t2n26Visible=!t2n26Visible">
                        <a href="javascript:" id="t2n26key">Comment puis-je amorcer un transfert de bail?</a>
                      </div>
                      <div class="faq-answer" id="t2n26" *ngIf="t2n26Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Veuillez contacter votre concessionnaire pour amorcer le processus de cession de bail, qui comprendra le remplissage et l’approbation d’une demande de crédit par le ou les cessionnaire(s). Une fois l’approbation de crédit fournie au concessionnaire, Services de location des concessionnaires automobiles canadiens travaillera directement avec votre concessionnaire pour s’assurer que tous les documents requis sont remplis et signés. Les frais de cession de bail seront également perçus par votre concessionnaire au moment du transfert du bail.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div class="faq-category-group">
                <div class="faq-qa-header">
                  <h3 class="faq-header">Fin de location</h3>
                </div>
                <div class="faq-qa">

                  <div class="faq-dl-hide-answer">
                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t3n16" (click)="t3n16Visible=!t3n16Visible">
                        <a href="javascript:" id="t3n16key">Quelles sont mes options de fin de location?</a>
                      </div>
                      <div class="faq-answer" id="t3n16" *ngIf="t3n16Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Vos options sont les suivantes :&nbsp;</p><ul><li>Retourner le véhicule au concessionnaire, ou</li><li>Acheter le véhicule, ou</li><li><a routerLink="/customer-intent">Soumettre intention fin de bail.</a></li></ul>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t3n17" (click)="t3n17Visible=!t3n17Visible">
                        <a href="javascript:" id="t3n17key">Suis-je responsable des réparations?</a>
                      </div>
                      <div class="faq-answer" id="t3n17"  *ngIf="t3n17Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p><strong>Option 1:</strong> Vous pouvez réparer votre véhicule chez votre concessionnaire ou dance un garage autorisé par votre concessionnaire. Si vous avez acheté un produit de protection contre l'usure excessive, veuillez contacter votre concessionnaire pour vous aider.&nbsp;</p><p><strong>Option 2:</strong> Vous pouvez choisir de faire les réparations dans un garage de votre choix. Une fois les réparations complétées, une 2e inspection à vos frais sera nécessaire. Pour en savoir plus sur le coût veuillez nous appeler.&nbsp;</p><p><strong>Option 3:</strong> Vous pouvez retourner votre véhicule sans effectuer de réparation. Dans ce cas, nous vous enverrons une facture pour les éléments d'usure excessive ainsi que les sommes restantes dues. Veuillez noter que dans la plupart des cas, nos véhicules sont vendus tel que retourné avec les divulgations nécessaires.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t3n27" (click)="t3n27Visible=!t3n27Visible">
                        <a href="javascript:" id="t3n27key">Puis-je transférer mon bail?</a>
                      </div>
                      <div class="faq-answer" id="t3n27" *ngIf="t3n27Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Veuillez contacter notre département de relation clients (1.888.703.5765) pour discuter des options disponibles.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t3n28" (click)="t3n28Visible=!t3n28Visible">
                        <a href="javascript:" id="t3n28key">J’ai acheté un produit de fin de bail; comment dois-je procéder?</a>
                      </div>
                      <div class="faq-answer" id="t3n28" *ngIf="t3n28Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Avec autant de produits disponibles, nous vous recommandons de discuter de votre couverture de protection spécifique avec votre concessionnaire.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="faq-category-group">
                <div class="faq-qa-header">
                  <h3 class="faq-header">Inspection</h3>
                </div>

                <div class="faq-qa">
                  <div class="faq-dl-hide-answer">

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t4n29" (click)="t4n29Visible=!t4n29Visible">
                        <a href="javascript:" id="t4n29key">Qui est Inspections OPENLANE?</a>
                      </div>
                      <div class="faq-answer" id="t4n29" *ngIf="t4n29Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Inspections OPENLANE (anciennement AutoVIN) est une entreprise tierce embauchée par nous pour effectuer le processus d’inspection des véhicules.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t4n30" (click)="t4n30Visible=!t4n30Visible">
                        <a href="javascript:" id="t4n30key">Pourquoi une inspection est-elle requise?</a>
                      </div>
                      <div class="faq-answer" id="t4n30" *ngIf="t4n30Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>À moins d’acheter le véhicule, une inspection est nécessaire pour évaluer l’usure excessive du véhicule avant son retour.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t4n31" (click)="t4n31Visible=!t4n31Visible">
                        <a href="javascript:" id="t4n31key">Dois-je être présent pendant l’inspection?</a>
                      </div>
                      <div class="faq-answer" id="t4n31" *ngIf="t4n31Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Non, ce n’est pas nécessaire. L’inspecteur effectuera l’inspection à l’endroit de votre choix. Habituellement, les résultats sont disponibles en ligne dans les 24 à 48 heures. Si vous ne savez pas où ni comment consulter vos résultats, contactez votre concessionnaire ou notre département de relation clients (1.888.703.5765).</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t4n32" (click)="t4n32Visible=!t4n32Visible">
                        <a href="javascript:" id="t4n32key">Quel numéro dois-je appeler pour prendre rendez-vous de mon inspection?</a>
                      </div>
                      <div class="faq-answer" id="t4n32" *ngIf="t4n32Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Pour prendre rendez-vous de votre inspection, veuillez contacter notre département de relation clients (1.888.703.5765).</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t4n33" (click)="t4n33Visible=!t4n33Visible">
                        <a href="javascript:" id="t4n33key">Pendant combien de temps l’inspection est-elle valide?</a>
                      </div>
                      <div class="faq-answer " id="t4n33" *ngIf="t4n33Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>L’inspection est valide pendant 60 jours. Si le véhicule n’est pas retourné dans les 60 jours après l’inspection, une deuxième inspection est requise et sera facturée au locataire. Toutefois, la première inspection est gratuite.</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>

                    <div class="faq-question-answer">
                      <div class="faq-question" role="button" aria-expanded="false" aria-controls="t4n34" (click)="t4n34Visible=!t4n34Visible">
                        <a href="javascript:" id="t4n34key">Comment puis-je confirmer que CDLSI a reçu la confirmation des réparations?</a>
                      </div>
                      <div class="faq-answer" id="t4n34" *ngIf="t4n34Visible">
                        <article class="faq full clearfix" aria-expanded="false">
                          <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                              <p>Il est important pour nous de recevoir une copie des reçus de réparation pour renoncer aux dommages qui ont été réparés. Pour confirmer la réception, veuillez contacter notre département de relation clients &nbsp;(1.888.703.5765).</p>
                            </div>
                          </div>
                        </article>
                        <a href="javascript:" title="Retourner en haut de page." (click)="backToTop()">Haut de page</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
      <aside class="col-sm-3">
        <div class="region region-sidebar-second">
          <section id="block-forlesseessidebar" class="block block-block-content clearfix">
            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
              <p class="btn btn-secondary">
                <button type="button" class="btn btn-secondary" (click)="submitInsuranceInfo()">Soumettre documents <br> d'assurance</button>
              </p>
            </div>
          </section>
        </div>
      </aside>
    </div>
  </div>
